import api from "../api/api";
const BASE_URL = import.meta.env.VITE_APP_API_URL;

// Função auxiliar para aguardar o relatório ficar pronto
const aguardarRelatorio = async (url, maxTentativas = 10, intervalo = 1000) => {
  for (let tentativa = 1; tentativa <= maxTentativas; tentativa++) {
    try {
      // Adiciona timestamp para evitar cache
      const urlComTimestamp = `${url}?t=${Date.now()}`;
      
      // Verifica se o relatório está pronto usando HEAD request
      const response = await fetch(urlComTimestamp, { 
        method: 'HEAD',
        cache: 'no-store',
        headers: {
          'Pragma': 'no-cache',
          'Cache-Control': 'no-cache'
        }
      });
      
      if (response.ok) {
        return urlComTimestamp; // Retorna a URL com timestamp
      }
    } catch (error) {
      console.log(`Tentativa ${tentativa}: Relatório ainda não disponível`);
    }
    
    // Aguarda o intervalo antes da próxima tentativa
    await new Promise(resolve => setTimeout(resolve, intervalo));
  }
  
  // Se chegou aqui, esgotou as tentativas
  throw new Error("Tempo limite excedido. O relatório não ficou disponível.");
};

// Função para abrir relatório em nova aba
const abrirRelatorio = (url) => {
  const urlComTimestamp = `${url}?t=${Date.now()}`;
  window.open(urlComTimestamp, '_blank');
};

export const sapeJodarcService = {
  sapeFichaComposicao: async (params) => {
    try {
      const url = `${BASE_URL}/sape-jodarc-ficha-composicao`;
      console.log(url);
      const response = await api.get(url, { params });
      return response.data;
    } catch (error) {
      console.error("Erro ao obter produtos:", error);
      throw new Error("Erro ao obter produtos.");
    }
  },
  
  sapePedido: async (params) => {
    try {
      const url = `${BASE_URL}/sape-jodarc-pedido`;
      console.log(url);
      const response = await api.post(url, params);
      return response.data;
    } catch (error) {
      console.error("Erro ao obter produtos:", error);
      throw new Error("Erro ao obter produtos.");
    }
  },

  // Gerar PDF da ficha de composição por ordem de producao do sape com atual - base - diferenca
  sapeFichaComposicaoPdf: async (params) => {
    try {
      const url = `${BASE_URL}/relatorio-ficha-composicao-pdf`;
      const response = await api.post(url, {
        produto: {
          referencia: params.produto
        },
        pedido_info: {
          id_pedido: params.pedido_info.id_pedido,
          docEntry: params.pedido_info.docEntry,
          cliente: params.pedido_info.cliente,
          produto_nome: params.pedido_info.produto_nome,
          produto_quantidade: params.pedido_info.produto_quantidade
        },
        tipo: params.tipo
      });
      
      // Se a resposta contém a URL do relatório
      if (response.data && response.data.arquivo) {
        // Apenas preparar a URL para o frontend usar
        response.data.pdfUrl = `${BASE_URL}/relatorioHtml/${response.data.arquivo}`;
      }
      
      return response;
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      throw error;
    }
  },
  
  // Gerar PDF da ficha de composição agrupado por modelo
  sapeFichaAgrupadoPorModeloPdf: async (params) => {
    try {
      const url = `${BASE_URL}/relatorio-ficha-producao-pedido-referencia-html`;
      const response = await api.post(url, {
        produto: {
          referencia: params.produto
        },
        pedido_info: {
          id_pedido: params.pedido_info.id_pedido,
          cliente: params.pedido_info.cliente,
          produto_nome: params.pedido_info.produto_nome,
          produto_quantidade: params.pedido_info.produto_quantidade
        },
        tipo: params.tipo
      });
      
      // Se a resposta contém a URL do relatório
      if (response.data && response.data.arquivo) {
        // Apenas preparar a URL para o frontend usar
        response.data.pdfUrl = `${BASE_URL}/relatorioHtml/${response.data.arquivo}`;
      }
      
      return response;
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      throw error;
    }
  },

  // Gerar relatório de ficha de composição simples em HTML
  sapeRelatorioFichaComposicaoSimplesHtml: async (params) => {
    try {
      const url = `${BASE_URL}/relatorio-ficha-composicao-simples-html`;
      const response = await api.post(url, {
        produto: {
          referencia: params.produto
        },
        pedido_info: {
          id_pedido: params.pedido_info.id_pedido,
          docEntry: params.pedido_info.docEntry,
          cliente: params.pedido_info.cliente,
          produto_nome: params.pedido_info.produto_nome,
          produto_quantidade: params.pedido_info.produto_quantidade
        },
        tipo: params.tipo
      });
      
      // Se a resposta contém a URL do relatório
      if (response.data && response.data.arquivo) {
        // Apenas preparar a URL para o frontend usar
        response.data.pdfUrl = `${BASE_URL}/relatorioHtml/${response.data.arquivo}`;
      }
      
      return response;
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      throw error;
    }
  },
  
  // Método utilitário para abrir relatórios diretamente
  abrirRelatorio: (url) => {
    abrirRelatorio(url);
  },
  
  // Método utilitário para verificar se um relatório está pronto
  verificarRelatorio: async (url) => {
    try {
      return await aguardarRelatorio(url, 1); // Apenas uma tentativa
    } catch (error) {
      return false;
    }
  }
};
